import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createVNode as _createVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "container-fluid" }
const _hoisted_2 = { class: "row g-0 justify-content-center" }
const _hoisted_3 = { class: "col-auto col-form" }

import {
  onMounted,
  onBeforeUnmount,
  computed,
  ref,
  watch,
  nextTick,
} from 'vue';

import { useStore } from 'vuex';
import SearchForm from '@/components/SearchForm/SearchForm.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'IoSearchForm',
  setup(__props) {

const store = useStore();
const root = ref<InstanceType<typeof HTMLElement>>();
const colSize = ref<InstanceType<typeof HTMLElement>>();
const searchFormInput = ref<InstanceType<typeof SearchForm>>();

const setColHeight = () => {
  const $wpAdminBar = document.querySelector('#wpadminbar') as HTMLElement;
  const $header = document.querySelector('header') as HTMLElement;

  let height = window.innerHeight;

  if ($wpAdminBar) {
    height -= $wpAdminBar.scrollHeight;
  }
  if ($header) {
    height -= $header.offsetHeight;
  }

  if (colSize.value) {
    colSize.value.style.height = `${height}px`;
  }
};

const show = computed(() => store.getters['search/showForm']);

const onClose = () => {
  setTimeout(() => {
    searchFormInput.value.form.query = null;
  }, 350);
};

const close = () => {
  store.dispatch('search/close');
  onClose();
};

const ifClickedOutside = (event: MouseEvent) => {
  if (searchFormInput.value) {
    const withinBoundaries = event.composedPath().includes(searchFormInput.value.$el);

    if (!withinBoundaries) {
      close();
    }
  }
};

watch(() => show.value, () => {
  if (show.value && root.value) {
    const searchInput: HTMLElement | null = root.value.querySelector('input[type=text]');

    nextTick(() => {
      if (searchInput) {
        searchInput.focus();
      }
    });
  } else if (!show.value) {
    onClose();
  }
});

onMounted(() => {
  window.addEventListener('resize', setColHeight);
  window.addEventListener('load', setColHeight);
  setColHeight();
  if (root.value) {
    root.value.addEventListener('click', ifClickedOutside);
  }
});

onBeforeUnmount(() => {
  window.removeEventListener('resize', setColHeight);
  window.removeEventListener('load', setColHeight);
  if (root.value) {
    root.value.removeEventListener('click', ifClickedOutside);
  }
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    ref_key: "root",
    ref: root,
    class: _normalizeClass(["io-search-form", { 'show': show.value }])
  }, [
    _createElementVNode("div", {
      class: "io-search-form__background",
      onClick: close
    }),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", {
          ref_key: "colSize",
          ref: colSize,
          class: "col-auto"
        }, null, 512),
        _createElementVNode("div", _hoisted_3, [
          _createVNode(SearchForm, {
            ref_key: "searchFormInput",
            ref: searchFormInput,
            onSearch: close
          }, null, 512)
        ])
      ])
    ])
  ], 2))
}
}

})